import i18n from '../../lang/index'
import util from '../../utils/util'
i18n.locale = util.getCookie("locale") || 'en';
const sqlRouter = [{
  path: '/database',
  component: () => import('@/pages/Index'),
  redirect: {
    name: 'rdslist'
  },
  children: [{
      name: 'sqllist',
      path: 'mysql',
      meta: {
        tab: '',
        title: 'MySQL',
      },
      component: () => import('@/pages/sql/MySql'),
    },
    {
      name: 'rdslist',
      path: 'rds',
      meta: {
        tab: '',
        title: 'MySQL',
      },
      component: () => import('@/pages/sql/Rds'),
    },
    {
      name: 'rdsdetail',
      path: 'detail',
      meta: {
        tab: '',
        title: 'MySQL',
      },
      component: () => import('@/pages/sql/Detail'),
    }
  ]
}]
export default sqlRouter



// WEBPACK FOOTER //
// ./src/router/modules/sql.js